const keys = {
  PAGE_LENGTH: 20,
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
  IM: "IM",
  TF: "TF",

  PROJECT_NAME: "Indian Mentors",
  PROJECT_LEGAL_NAME: "AFRISHA INDIAN MENTORS PRIVATE LIMITED",

  MINIMUM_WITHDRAW_AMOUNT: 1000,

  ACCOUNT_STUDENT: "Student",
  ACCOUNT_TEACHER: "Teacher",
  ACCOUNT_ADMIN: "Admin",
  ACCOUNT_SUPER_ADMIN: "Super Admin",

  ACCOUNT_ADMISSION_COUNSELLOR: "Admission Counsellor",
  ACCOUNT_ACADEMIC_COUNSELLOR: "Academic Counsellor",
  ACCOUNT_ADMISSION_COORDINATOR: "Admission Coordinator",
  ACCOUNT_RECRUITMENT_MANAGER: "Recruitment Manager",

  PRODUCTION: "PRODUCTION",
  STAGING: "STAGING",
  LOCAL: "LOCAL",

  PAYMENT_MODE: "Payment mode",
  MODE_CASH: "Cash",
  MODE_CHEQUE: "Cheque",
  MODE_PAYMENT_GATEWAY: "Payment Gateway",

  /* subscription  type */
  BASIC_PLAN: "Basic",
  STANDARD_PLAN: "Standard",
  PREMIUM_PLAN: "Premium",
  ADD_ON_PLAN: "Add-on",

  PROFILE_COMPLETE: "Completed",
  PROFILE_INCOMPLETE: "Incomplete",
  PROFILE_ACTIVE: "Active",
  CREDIT: "Credit",
  DEBIT: "Debit",

  /* action keys */
  RE_ASSIGN: "Re-Assign",
  RE_SCHEDULE: "Re-Schedule",
  DEAD: "Dead",
  MAKES_AS_CONVERTED: "Makes As Converted",
  COMMENT: "Comment",
  ACTION_ADD: "action_add",
  ACTION_EDIT: "action_edit",
  SCHEDULE_DEMO: "Schedule Demo",

  CONTRACT_PENDING: "Pending",
  CONTRACT_EXPIRED: "Expired",
  CONTRACT_ACTIVE: "Active",
  CONTRACT_REJECTED: "Rejected",
  INTERVIEW_SCHEDULED: "Interview Scheduled",

  RESULT_PENDING: "Pending",
  RESULT_SELECTED: "Selected",
  RESULT_REJECTED: "Rejected",

  TYPE_CONTACT_FORM: "contact_form",
  TYPE_ADDRESS_FORM: "address_form",
  TYPE_ACADEMICS_FORM: "academics_form",
  TYPE_OTHER_FORM: "other_form",

  HOMEWORK_PENDING: "Pending",
  HOMEWORK_COMPLETED: "Completed",
  HOMEWORK_PARTIALLY_COMPLETED: "Partially Completed",
  HOMEWORK_NOT_COMPLETED: "Not Completed",

  PAYMENT_FAILED: "Failed",
  PAYMENT_SUCCESS: "Success",
  PAYMENT_PROCESSING: "Processing",
  PAYMENT_INITIATED: "Initiated",
  PAYMENT_UPCOMING: "Upcoming",
  PAYMENT_OVERDUE: "Overdue",

  TYPE_STUDENT_REGISTRATION: "student_registration",
  TYPE_TUTOR_REGISTRATION: "tutor_registration",
  TYPE_SUBSCRIPTION_PAYMENT: "subscription_payment",
  TYPE_EMI_PAYMENT: "emi_payment",

  MAX_FILE_SIZE: 4,
  ACCEPTED_IMAGE_FORMATE: ["image/jpeg", "image/png", "image/jpg"],

  GENDER_OPTIONS: ["Male", "Female", "Other"],
  PAYMENT_TYPE_INSTALLMENT: "Installment",

  EMI_STATUS_PARTIALLY_PAID: "Partially Paid",
  EMI_STATUS_PAID: "Paid",
  EMI_STATUS_DUE: "Due",
  EMI_STATUS_OVERDUE: "Overdue",

  PAYOUT: "payout",

  SUCCESS: "Success",
  WARNING: "Warning",

  PAYOUT_STATUS_PENDING: "Pending",
  PAYOUT_STATUS_APPROVED: "Approved",
  PAYOUT_STATUS_REJECTED: "Rejected",

  SESSION_STATUS: "session_status",
  SESSION_PENDING: "Pending",
  SESSION_REJECTED: "Rejected",
  SESSION_APPROVED: "Approved",

  DEMO_SCHEDULED: "Scheduled",
  DEMO_RESCHEDULED: "Rescheduled",
  DEMO_SELECTED: "Selected",
  DEMO_REJECTED: "Rejected",

  WEEKDAYS_OPTION: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  CLASS_MODE_OPTION: ["Online", "Offline"],
  STUDENT_TEACHING_PREFERENCE_OPTION: [
    "My Home",
    "Tutor's Home",
    "Tuition Center",
    "Coaching Center",
  ],
  TUTOR_TEACHING_PREFERENCE_OPTION: [
    "My Home",
    "Student's Home",
    "Tuition Center",
    "Coaching Center",
    "School",
    "College",
  ],

  COUNSELLING_SCHEDULED: "Scheduled",
  COUNSELLING_RESCHEDULED: "Rescheduled",
  COUNSELLING_COMPLETED: "Completed",
  COUNSELLING_CANCELLED: "Cancelled",
};

export default keys;
